export default __webpack_public_path__ + "images/GQ.e60301c.png";